<script>
    export default {
    data () {
        return {
            Usuario:null,
            auto:null,
            co:null,
            jefe:null,
            retro:null,
        }
    },
    created () {
        axios.get('/api/get_tipoevaluaciones').then(res=>{
            this.auto = res.data.auto;
            this.co = res.data.co;
            this.jefe = res.data.jefe;
            this.retro = res.data.retro;
        });

        axios.get('/api/get_data_usuario')
        .then(res=> {
                if(res.data.estado){
                    this.Usuario = res.data.usuario
                    //console.log(this.Usuario);
                }
        })
        .catch(function (error) {
            // manejar error
            if (error.response) {
            // La respuesta fue hecha y el servidor respondió con un código de estado
            // que esta fuera del rango de 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            } else if (error.request) {
            // La petición fue hecha pero no se recibió respuesta
            // `error.request` es una instancia de XMLHttpRequest en el navegador y una instancia de
            // http.ClientRequest en node.js
            console.log(error.request);
            } else {
            // Algo paso al preparar la petición que lanzo un Error
            console.log('Error', error.message);
            }
            console.log(error.config); 
        })
    },    
    }
</script>
<template>
    <div>
        <div class="col-lg-6">
            <div class="card  ml-4 mb-4 mr-4 ">
                <div class="card-body">
                    <!---------- Columnas en fila ---------->
                    <div class='col-md-12'>
                        <h4 class="card-title mb-4 text-dark">Procesos:</h4>
                        <div class='row'>
                            <div class='col-md-3 mb-2'>
                    <!---------- CONTENIDO 1 ---------->
                    <!---------- Botón ---------->
                                <b-button v-if="auto" size='sm' variant='info' :href="('/evaluacion/'+Usuario.id)">Autoevaluación</b-button>
                            </div>
                            <div class='col-md-3 mb-2'>
                    <!---------- CONTENIDO 2 ---------->
                                <b-button v-if="co" size='sm' variant='info' href="/app/evaluaciones/coevaluacion">Co evaluación</b-button>
                            </div>
                            <div class='col-md-3 mb-2'>
                    <!---------- CONTENIDO 3 ---------->
                                <b-button v-if="jefe" size='sm' variant='info' href="/app/evaluaciones/deljefe">Evaluación jefatura</b-button>
                            </div>
                            <div class='col-md-3 mb-2'>
                    <!---------- CONTENIDO 4 ---------->
                                <b-button v-if="retro" size='sm' variant='info' href="">Retroalimentación</b-button>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="card bg-primary ml-4 mb-4 mr-4 " v-if="Usuario">
                <div class="card-body">
                    <h4 class="card-title mb-4 text-light">Información:</h4>
                    <div class="table-responsive">
                        <table class="table table-nowrap mb-0 text-light">
                            <tr>
                                <th>Nombre:</th>
                                <td>{{Usuario.nombre}} {{Usuario.apellidoPaterno}} {{Usuario.apellidoMaterno}}</td>
                            </tr>
                            <tr>
                                <th>Rut:</th>
                                <td>{{Usuario.rut}}-{{(Usuario.rut_dv)}}</td>
                            </tr>
                            <tr>
                                <th>Correo Institucional:</th>
                                <td>{{Usuario.email}}</td>
                            </tr>
                            <!-- <tr>
                                <th>Matricula Curso año 2022:</th>
                                <td>{{curso_2022.descripcionGrado}} {{curso_2022.letra}}</td>
                            </tr> -->
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>

</style>